export const getPermissionsRequest_v3_schema = {
  type: 'object',
  properties: {
    objectName: {
      type: 'string',
    },
  },
  required: ['objectName'],
};
